module.exports = __webpack_public_path__ + "assets/46afeae4ae63fc453ec96d45e1a928ae.wav";